var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadixIconsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40005 3.99998C6.40005 3.7878 6.48433 3.58432 6.63436 3.43429C6.78439 3.28426 6.98788 3.19998 7.20005 3.19998H16.8C17.0122 3.19998 17.2157 3.28426 17.3657 3.43429C17.5158 3.58432 17.6 3.7878 17.6 3.99998V20C17.6 20.2122 17.5158 20.4156 17.3657 20.5657C17.2157 20.7157 17.0122 20.8 16.8 20.8H7.20005C6.98788 20.8 6.78439 20.7157 6.63436 20.5657C6.48433 20.4156 6.40005 20.2122 6.40005 20V3.99998ZM7.20005 1.59998C6.56353 1.59998 5.95308 1.85283 5.50299 2.30292C5.05291 2.75301 4.80005 3.36346 4.80005 3.99998V20C4.80005 20.6365 5.05291 21.2469 5.50299 21.697C5.95308 22.1471 6.56353 22.4 7.20005 22.4H16.8C17.4366 22.4 18.047 22.1471 18.4971 21.697C18.9472 21.2469 19.2 20.6365 19.2 20V3.99998C19.2 3.36346 18.9472 2.75301 18.4971 2.30292C18.047 1.85283 17.4366 1.59998 16.8 1.59998H7.20005ZM9.60005 18.64C9.45153 18.64 9.30909 18.699 9.20407 18.804C9.09905 18.909 9.04005 19.0515 9.04005 19.2C9.04005 19.3485 9.09905 19.4909 9.20407 19.596C9.30909 19.701 9.45153 19.76 9.60005 19.76H14.4C14.5486 19.76 14.691 19.701 14.796 19.596C14.901 19.4909 14.96 19.3485 14.96 19.2C14.96 19.0515 14.901 18.909 14.796 18.804C14.691 18.699 14.5486 18.64 14.4 18.64H9.60005Z",
    fill: "#8C9FB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadixIconsMobile);
export default __webpack_public_path__ + "static/media/radix-icons_mobile.4edcc9934e268179438819aa07c4cee7.svg";
export { ForwardRef as ReactComponent };